export default __webpack_public_path__ + "static/media/home_id_img.22883520.png";